export default __webpack_public_path__ + "static/media/addrow-icon.d56f13ef.svg";